import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import ProjectGallery from "@/components/ProjectGallery";
import CtaBand from "@/components/CtaBand";
import { api } from "@/lib/api";

export default function OurWork() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/projects")
      .then((r) => setProjects(r.data))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo
        title="Our Work & Recent Projects"
        description="Browse recent Kensmarc Electric projects — residential, commercial, industrial, panel work, lighting, and CCTV installations across Los Angeles County."
        path="/our-work"
      />
      <PageHeader
        eyebrow="Our Work"
        title="Recent projects"
        subtitle="A look at the kind of work Kensmarc Electric takes on — residential, commercial, industrial, and CCTV. Real project photos and videos are added here as they're ready."
      />

      <section className="section-pad">
        <div className="container-kx">
          <ProjectGallery projects={projects} loading={loading} />
        </div>
      </section>

      <CtaBand title="Want work like this?" />
    </>
  );
}
